import React from "react"

interface IProps {
    isOpen: boolean
}

function Spinner({isOpen}: IProps) {
    if (!isOpen) {
        return null
    }
    const $overlay = (
        <div className={"fixed inset-0 bg-gray-100 opacity-80 z-10"} />
    )

    const $content = (
        <div className={"z-20 flex flex-col items-center justify-center"}>
            <div className={"animate-spin h-12 w-12"}>
                <svg d="1643179482462" className="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2051" width="48" height="48">
                    <path
                        d="M512 1024c-136.768 0-265.344-53.248-362.048-149.952S0 648.768 0 512c0-96.832 27.168-191.136 78.592-272.704a513.952 513.952 0 0 1 204.352-185.312l43.008 85.824a417.408 417.408 0 0 0-166.144 150.656A414.496 414.496 0 0 0 96 511.968c0 229.376 186.624 416 416 416s416-186.624 416-416c0-78.688-22.08-155.296-63.808-221.504a417.632 417.632 0 0 0-166.144-150.656l43.008-85.824a513.504 513.504 0 0 1 204.352 185.312A510.496 510.496 0 0 1 1024 512c0 136.768-53.248 265.344-149.952 362.048S648.768 1024 512 1024z"
                        p-id="2052" fill="#2F80ED"/>
                </svg>
            </div>
            <p className={"mt-2 text-sm text-primary font-semibold"}>{"Loading..."}</p>
        </div>
    )

    return (
        <div className={"fixed inset-0 flex items-center justify-center w-full z-50"}>
            {$overlay}
            {$content}
        </div>
    )
}

export default Spinner
